import { render, staticRenderFns } from "./SettingsDocTypes.vue?vue&type=template&id=b1f4fcdc"
import script from "./SettingsDocTypes.vue?vue&type=script&lang=js"
export * from "./SettingsDocTypes.vue?vue&type=script&lang=js"
import style0 from "./SettingsDocTypes.vue?vue&type=style&index=0&id=b1f4fcdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports